import { useState } from "react";
import { useApiFetch } from '@/helper/apiFetch';
import { Button } from '@/components/ui/button';


export function URLShortenerPage() {

  const apiFetch = useApiFetch();
  const [history, setHistory] = useState<string>("");
  const [longUrl, setLongUrl] = useState<string>("");
  const [shortUrl, setShortUrl] = useState<string>("");
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [submitError, setSubmitError] = useState<string>("");


  const loadHistory = () => {

    apiFetch(`/api/link/GetHistory`, {
        method: "POST",
        headers: { "Content-Type": "application/json" }
      })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch sites");
        
        res.text().then((text) => {
          if (text) {
            setHistory(text);
          }
      })
      })
      .catch((err) => {
        console.error(err);
      });


  }

  const shortenUrl = async () => {
    const trimmedUrl = longUrl.trim();
    if (!trimmedUrl) return;

    setSubmitError("");
    setIsSubmitting(true);

    try {
      const formData = new FormData();
      formData.append("urlLong", trimmedUrl);

      const res = await apiFetch(`/api/link/GetShortUrl`, {
        method: "POST",
        body: formData,
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "Failed to shorten URL");
      }

      let nextShortUrl = "";

    
        const data = await res.json();
        if(data?.message != "")
           setSubmitError(data.message);
        nextShortUrl = data?.urlShort ?? "";
     

      setShortUrl(nextShortUrl.trim());
    
    } catch (err) {
      setSubmitError(err instanceof Error ? err.message : "Failed to shorten URL");
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };






  return (
    <div className="h-[calc(100vh-60px)] flex flex-col">
      <div className="content-header flex justify-between border-b border-gray-300 pt-[0.6rem] pb-[0.6rem] mb-[0.8rem]">
        <div className="flex items-center gap-8 w-[100%]">

          <div className="w-full flex flex-col gap-2">
            <div className="w-full flex items-center gap-3">
              <div className="inline-flex h-9 items-center rounded-md border border-gray-300 bg-gray-100 px-4 text-sm text-gray-700">
                URL
              </div>
             
           
                <input
                type="text"
                value={longUrl}
                onChange={(e) => setLongUrl(e.target.value)}
                placeholder="Shorten your Link"
                className="h-9 flex-1 rounded-md border border-gray-300 px-3 text-sm focus:outline-none focus:ring-1 focus:ring-gray-400"
              />
              <Button
                type="button"
                className="h-9 min-w-40 !bg-blue-500 !text-white"
                disabled={isSubmitting || !longUrl.trim()}
                onClick={shortenUrl}
              >
                {isSubmitting ? "Shortening..." : "Shorten"}
              </Button>
        
              
              
            </div>

            {shortUrl && (
              <div className="text-sm text-gray-700">
                Short URL: <a className="text-blue-600 hover:underline" href={shortUrl} target="_blank" rel="noreferrer">{shortUrl}</a>
                <Button
                  type="button"
                  variant="outline"
                  size="sm"
                  className="ml-3"
                  onClick={() => navigator.clipboard.writeText(shortUrl)}
                >
                  Copy short URL
                </Button>
              </div>
            )}

            {submitError && <div className="text-sm text-red-600">{submitError}</div>}
          </div>

         
          
        </div>
        
      </div>

  {history == "" && (
      <Button
                                        type="button"
                                        variant="outline"
                                        size="sm"
                                        className="max-w-[200px] text-xs uppercase"
                                        onClick={() => {
      
                                          loadHistory();
      
                                        }}
                                      >
                                        Show History
                                      </Button>)}

        <div className="flex-1 overflow-auto">
          <div className="overflow-x-auto pb-5">


            <div
              className="history-html rounded  bg-white p-4"
              dangerouslySetInnerHTML={{ __html: history ?? "" }}
            />

          </div>
        </div>
     
    </div>
  );
}
